import React from 'react';
import { Formik, Form, FormikHelpers } from 'formik';
import Button from '../button/index';
import TextArea from '../text-area/index';
import { useDiscardCart } from '../../../integrations/react_query/mutations';

type TDiscardValues = {
	note: string;
};

const initialValues: TDiscardValues = {
	note: '',
};

type DiscardSalesContentProps = {
	onClose: () => void;
};

export const DiscardSalesContent = ({ onClose }: DiscardSalesContentProps) => {
	const { mutateAsync, isLoading } = useDiscardCart();

	const onSubmit = async (values: TDiscardValues, actions: FormikHelpers<TDiscardValues>) => {
		await mutateAsync(values.note);
		onClose();
	};

	return (
		<div className="px-5 py-4">
			<Formik initialValues={initialValues} onSubmit={onSubmit}>
				{({ values, setFieldValue, isSubmitting }) => (
					<Form className="space-y-4">
						<TextArea
							label="Note"
							placeholder="Please provide a reason for discarding this sale..."
							value={values.note}
							onChange={(e: React.ChangeEvent<HTMLTextAreaElement>) => setFieldValue('note', e.target.value)}
							required
						/>

						<div className="w-100 text-center my-3">
							<Button
								type="button"
								disabled={false}
								isBordered={true}
								styles="py-4 mx-3"
								style={{ width: '35%' }}
								onClick={() => onClose()}
							>
								Cancel
							</Button>
							<Button type="submit" disabled={isLoading} style={{ width: '35%' }} styles="py-4">
								{isLoading ? 'Discarding...' : 'Discard'}
							</Button>
						</div>
					</Form>
				)}
			</Formik>
		</div>
	);
};

export default DiscardSalesContent;
